import { IconButton, Select } from '@mui/material';
import styled from '@emotion/styled';
import { commonBorderLight } from 'themes';
import { RowStack } from 'components/styled';

export const StyledSelectMenu = styled(Select)`
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 4px;
  border: ${commonBorderLight};
  background-color: #fff;
  padding: 6px 6px !important;
  padding-left: 12px !important;
  box-shadow: none;
  padding: 0;

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  & .MuiSelect-select {
    padding: 0;
  }
`;
export const StyledPaginationWrapper = styled(RowStack)(() => ({
  border: commonBorderLight,
  borderRadius: '8px',
  backgroundColor: 'white',
}));

export const StyledPaginationButton = styled(IconButton)(
  ({ padding, backgroundColor }: { padding: string; backgroundColor?: string }) => ({
    padding: padding,
    borderRadius: '4px',
    backgroundColor: backgroundColor,
  }),
);

export const StyledPaginationButtonOtherStyle = styled(IconButton)(
  ({ padding, backgroundColor }: { padding: string; backgroundColor?: string }) => ({
    padding: padding,
    border: commonBorderLight,
    borderRadius: '8px',
    backgroundColor: backgroundColor,
  }),
);
